import React from 'react';
import { parseRichText } from '../utils/richText';
import '../styles/richText.css';

/**
 * Shows a description or note written with the formatting editor
 * (components/RichTextEditor.js): bold, italic, lists and links. Old plain
 * text shows as it always did, line breaks included.
 *
 *   <RichText text={task.description} className="task-description-text" />
 *
 * Everything is drawn as React elements from utils/richText.js; nothing typed
 * is put on the page as HTML. Links open in a new tab.
 */
const Runs = ({ runs }) => runs.map((r, i) => {
    if (r.br) return <br key={i} />;
    let node = r.text;
    if (r.italic) node = <em>{node}</em>;
    if (r.bold) node = <strong>{node}</strong>;
    if (r.href) {
        return (
            <a key={i} href={r.href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                {node}
            </a>
        );
    }
    return <React.Fragment key={i}>{node}</React.Fragment>;
});

const Blocks = ({ blocks }) => blocks.map((b, i) => {
    if (b.type === 'p') return <p key={i}><Runs runs={b.runs} /></p>;
    const items = b.items.map((item, n) => <li key={n}><Blocks blocks={item} /></li>);
    return b.type === 'ol'
        ? <ol key={i} start={b.start !== 1 ? b.start : undefined}>{items}</ol>
        : <ul key={i}>{items}</ul>;
});

const RichText = ({ text, className = '', fallback = null, as: Tag = 'div', style }) => {
    const blocks = parseRichText(text);
    if (!blocks.length) return fallback;
    return (
        <Tag className={`rich-text ${className}`.trim()} style={style}>
            <Blocks blocks={blocks} />
        </Tag>
    );
};

export default RichText;
